export const STATUS_COLORS = {
    'done': '#75CC9E',
    'in-progress': '#8DB0FB',
    'waiting': '#7E8C9A',
    'error': '#F26464',
    'awaiting-approval': '#F2B84B',
};
export const getStatusColor = (status) => {
    return STATUS_COLORS[status] || STATUS_COLORS.waiting;
};
